/* eslint-disable react/prop-types */

import React from 'react'
import { Redirect } from 'react-router-dom'

import { VISA_ERROR_STATES } from '../components/visa-plus/utils/route-check'

function WithExperienceCheck(Component, feature) {
  // NOTE: Add your error states to be consumed here, keyed by feature.
  const UI_ERRORS = {
    visaPlus: VISA_ERROR_STATES,
  }

  return function WithExperienceCheckComponent({
    showExperience = false,
    errorType = '',
    ...props
  }) {
    const errorObj = UI_ERRORS?.[feature]?.[`${errorType}`] || {
      pathname: '/error',
    }

    if (showExperience) {
      return <Component {...props} />
    }
    return <Redirect to={errorObj} />
  }
}

export { WithExperienceCheck }
